// extracted by mini-css-extract-plugin
export default {"wrapper":"RadioBtn_wrapper__kA0N+","input":"RadioBtn_input__pjqnv","label":"RadioBtn_label__CKh2J"};